import { BRANDS } from '../components/Itv/types';

const ITV_GAME_DETAILS_BASE = `/:brand/game-details`;
const ITV_BINGO_DETAILS_BASE = `/:brand/bingo-details`;

export const APP_URLS = {
  home: '/',
  registration: '/registration',
  login: '/login',
  help: 'https://help.itvwin.com',
  virtualGames: {
    home: '/virtual-games',
  },
  myAccount: {
    home: '/my-account',
    profile: '/my-account/profile',
    activity: '/my-account/activity',
    settings: '/my-account/settings',
    gamblingControls: '/my-account/gambling-controls',
    bonusHistory: '/bonus-history',
  },
  promotionsRoot: '/promotions',
  promotions: '/promotions/:id?/:subId?',
  contentPage: '/pages/:slug',
  gam: '/gam/:slug',
  ftp: '/ftp/:slug',
  gameLobby: {
    main: '/game-lobby',
    dynamicPage: '/game-lobby/:category/:subcategory?',
  },
  minigames: '/minigames',
  survey: '/survey',
  privacyPolicy: '/pages/privacy-policy',
  cookiePolicy: '/pages/cookie-policy',
  terms: '#terms',

  itv: {
    root: '/',
    landing: '/landing/:slug',
    promotionRoot: '/promotion',
    promotion: '/:brand/promotion/:id?/:subId?',

    prizes: `/${BRANDS.PRIZES}`,
    prizesSubPages: `/${BRANDS.PRIZES}/:subpage`,

    spins: `/${BRANDS.SPINS}`,
    spinsSubPages: `/${BRANDS.SPINS}/:subpage`,
    spinsRegistration: `/${BRANDS.SPINS}/registration`,

    bingo: `/${BRANDS.BINGO}`,
    bingoSubPages: `/${BRANDS.BINGO}/:subpage`,
    bingoRegistration: `/${BRANDS.BINGO}/registration`,

    collectionViewAll: `/:brand/:subpage/:collection`,
    gameDetailsBase: ITV_GAME_DETAILS_BASE,
    gameDetails: `${ITV_GAME_DETAILS_BASE}/:name/*`,

    bingoDetailsBase: ITV_BINGO_DETAILS_BASE,
    bingoDetails: `${ITV_BINGO_DETAILS_BASE}/:name/*`,
    privacyPolicy: '/:brand/pages/privacy-policy',
    cookiePolicy: '/:brand/pages/cookie-policy',
    contentPage: '/:brand/pages/:slug',
    gam: '/:brand/gam/:slug',
  },
};
